
/************************* TAX Toggel *************************/

class ToggleTax extends HTMLButtonElement {
    static get observedAttributes() { return ['aria-checked']; }

    constructor() {
        super();

        this.dom = {
            heading: this.querySelector('.heading')
        }

        this.settings = {
            strings: {
                heading_inclusive: this.getAttribute('inclusive'),
                heading_exclusive: this.getAttribute('exclusive')
            }
        }
    }

    connectedCallback() {
        this.init();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.updateStyle(this);
    }

    get isChecked() {
        return this.getAttribute("aria-checked") === "true";
    }
    set isChecked(value) {
        this.setAttribute("aria-checked", value ? "true" : "false");
    }

    init() {
        this.Click = this.Click.bind(this);
        this.addEventListener('click', this.Click)
    }

    Click() {
        this.isChecked = !this.isChecked;
    }

    async updateStyle() {
        this.toggleGlobalClass();
        this.changeText();

        fetch(`${ window.themeVariables.routes.cartUpdate }.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: { '_show-tax': this.isChecked.toString() },
            }),
        });

        document.dispatchEvent(new CustomEvent("toggle-taxes", {
            bubbles: true,
            detail: {
                show_taxes: this.isChecked
            }
        }
        ))
    }


    toggleGlobalClass() {
        if (this.isChecked) {
            document.body.classList.remove('no-tax')
        }
        else {
            document.body.classList.add('no-tax')
        }
    }

    changeText() {
        if (this.isChecked) {
            this.dom.heading.innerText = this.getAttribute('inclusive');
        }
        else {
            this.dom.heading.innerText = this.getAttribute('exclusive');
        }
    }
}
customElements.define('toggle-tax', ToggleTax, { extends: "button" });



class TaxPrice extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.eventTrigger = this.eventTrigger.bind(this);
        document.addEventListener('toggle-taxes', (this.eventTrigger));
        if (document.body.classList.contains('no-tax')) {
            this.updatePrice(false);
        }
    }
    disconnectedCallback() {
        document.removeEventListener('toggle-taxes', (this.eventTrigger));
    }
    eventTrigger(event) {
        this.updatePrice(event.detail.show_taxes);
    }
   async updatePrice(showTax = true) {
        if (showTax) {
            this.innerText = this.getAttribute('inclusive');
        } else {
            this.innerText = this.getAttribute('exclusive');
        }
    }
}
customElements.define('tax-price', TaxPrice);


class TaxText extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.eventTrigger = this.eventTrigger.bind(this);
        document.addEventListener('toggle-taxes', (this.eventTrigger));
        if (document.body.classList.contains('no-tax')) {
            this.updateText(false);
        }
    }
    disconnectedCallback() {
        document.removeEventListener('toggle-taxes', (this.eventTrigger));
    }
    eventTrigger(event) {
        this.updateText(event.detail.show_taxes); 
    }
   async updateText(showTax = true) {
        if (showTax) {
            this.innerText = this.getAttribute('inclusive');
        } else {
            this.innerText = this.getAttribute('exclusive');
        }
    }
}
customElements.define('tax-text', TaxText);